import { Flag, TrendUp } from '@phosphor-icons/react';
import { SEASON_WAYPOINTS } from '../shared/economy';
import type { StudentDashboardData } from './types';

export function SeasonElevation({ season, current, best, freezes = 1, message }: {
  season: StudentDashboardData['season']; current: number; best: number; freezes?: number; message?: string;
}) {
  const everest = SEASON_WAYPOINTS.find(point => point.label === 'Everest')!.feet;
  const height = Math.min(92, 8 + (season.feet / everest) * 84);
  const latest = season.passed[season.passed.length - 1];
  return <article className="stat-card altitude-card">
    <div className="card-top"><span className="section-kicker"><TrendUp size={18} weight="fill" /> Elevation</span></div>
    <div className="altitude-number"><strong>{season.feet.toLocaleString()}</strong><span>feet climbed this school year</span></div>
    <p className="altitude-milestone">{latest ? `${latest.badge} Reached ${latest.label}` : 'At the trailhead'}</p>
    <div className="altimeter" aria-hidden="true"><div className="altitude-fill" style={{ height: `${height}%` }}><Flag size={20} weight="fill" /></div></div>
    <p className="altitude-best">Current streak <strong>{current} day{current === 1 ? '' : 's'}</strong> · Best <strong>{best} day{best === 1 ? '' : 's'}</strong></p>
    <p>🧊 {freezes} streak {freezes === 1 ? 'freeze' : 'freezes'} ready · days off are protected</p>
    {message && <p className="math-footnote">{message}</p>}
  </article>;
}
